import React, { Component } from "react";
import { db } from '../config/fire';
import Redirec from "./Redirec";
import Roomi from "../components/RoomMain";
import { auth } from "../config/fire";
import Loader from "../components/Loader";


export default class Room extends Component{
    constructor(props){
        super(props);
       document.title = 'Loading...'
        this.state = {

            roomId: this.props.match.params.roomID,
            load: true,
            meetname : '',
            host: false,
            user: auth().currentUser,
            status: '',
            isRoom: false,
        }
        localStorage.clear();
    }
    componentDidMount(){
        const roomref = db().ref('all-rooms/'+ this.state.roomId);
    roomref.once('value', snapshot => {
        console.log(snapshot.val());
        const data = snapshot.val();
        if(snapshot.exists()){
            if(data.host == this.state.user.uid){
                roomref.update({
                    status: 'ACTIVE'
                })
                this.setState({
                    host: true,
                    meetname: data.title,
                })
            }
            console.log("There is")
            this.setState({
                isRoom: true,
                load: false,
                status: data.status,
                meetname: data.title,
            })

        }
        else{
            console.log('There is no')
            this.setState({

                load:false,
                isRoom: false
            })
            this.props.history.push('/');
        }
    })

    }
    render(){
        return (
            this.state.load == true ? <Loader/> :
            this.state.isRoom == true && this.state.host == true ?<Roomi title={this.state.meetname} host={true} roomid={this.state.roomId}></Roomi> :
            this.state.isRoom == true ? 
            this.state.status == 'ACTIVE'? 
            <Redirec title={this.state.meetname} roomid={this.state.roomId}> </Redirec> : <div>The Host is Not Started Yet</div> :
            <div>There is No Room</div>
        )
    }

}



